import { invoke } from '@forge/bridge';
import { DataNode } from 'rc-tree/lib/interface';

import {
    CreateRTModuleConfigModel,
    RegexConfigModel,
    SaveConfigModel,
    SaveSettingsModel,
} from '../../../../src/storage/interfaces';

class StorageApi {
    saveConfig(fieldId: string, contextId: string, treeData: SaveConfigModel): Promise<void> {
        return invoke('save-config', { fieldId, contextId, treeData });
    }

    getConfig(fieldId: string, contextId: string): Promise<DataNode[] | Promise<string[]>> {
        return invoke('get-config', { fieldId, contextId });
    }

    saveSettings(fieldId: string, contextId: string, data: SaveSettingsModel): Promise<void> {
        return invoke('save-settings', { fieldId, contextId, data });
    }

    getSettings(fieldId: string, contextId: string): Promise<SaveSettingsModel> {
        return invoke('get-settings', { fieldId, contextId });
    }

    getCreateRtModuleConfig(): Promise<CreateRTModuleConfigModel> {
        return invoke<CreateRTModuleConfigModel>('get-create-rt-module-config');
    }

    setCreateRtModuleConfig(config: CreateRTModuleConfigModel): Promise<void> {
        return invoke('set-create-rt-module-config', { config });
    }
}

export default new StorageApi();
